import api from "../../services/api";

export default {
  addId: ({ commit }, payload) => commit("addId", payload),

  fetchCompany: async ({ commit }, label) => {
    const response = await api.get(`api/v1/talent/${label}`);

    const { data } = response.data;

    commit("company", { ...data });
  }
};
